import { connect } from 'react-redux';

import actions from 'actions';

export default (Component, mapStateToProps=null) => connect(mapStateToProps, actions)(Component);
